<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full " src="img/lavatotem.png" width="145" height="30" alt="Alcance Logo">
        <img class="navbar-brand-minimized" src="favicon.ico" width="30" height="30" alt="Alcance Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none " display="lg" />
      <b-navbar-nav class="ml-auto no-print ">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body ">
      <AppSidebar fixed class="no-print">
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
      <div v-if="$store.getters.homologacao" class="test" > <div class="center">VOCÊ ESTA NO AMBIENTE DE TESTES</div> </div>
        <Breadcrumb :list="list" class="no-print"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed>
        <DefaultAside/>
      </AppAside> -->
    </div>
    <TheFooter class="no-print">
      <!--footer-->
      <div>
        <a href="https://www.prismafive.com.br/">LavaTotem</a>
        <span class="ml-1">&copy; 2023 </span>
        <p id="version" style="display: inline;"></p>
      </div>
      <div class="ml-auto">
        <span v-html="BuscarRodape"></span>
        
      </div>
      <div class="ml-auto">
        <span class="mr-1">Desenvolvido por</span>
        <a href="https://www.prismafive.com.br/">Prismafive</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import navHospital from '@/navs/_navHospital'
import navLavanderia from '@/navs/_navLavanderia'
import navTotem from '@/navs/_navTotem'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import { isElectron } from '../shared/isElectron';
import packageJson from '../../package.json';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav:  this.getNav()
    }
  },
  methods: {
    getNav(){
      let adm = this.$store.getters.getAutenticacao.administrador;
      switch (this.$store.getters.getAutenticacao.perfil) {
        case 2:
            return navLavanderia.items;
        case 3: 
            return navHospital.items;
        case 4:
            return navTotem.items;
        default:
            return navHospital.items;
      }
    },
  },
  computed: {
    BuscarRodape(){
      switch (this.$store.getters.getAutenticacao.perfil) {
        case 2:
          return 'Dúvidas? Ligue para o nosso <a href="https://prismafive.movidesk.com/Account/Login?ReturnUrl=%2f" target="_blank">Suporte</a>';
        default:
          return 'Dúvidas? Ligue para a Hospitalave (47) 3240-0700';
      }
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  async mounted() {
    const version = document.getElementById('version');
    if (isElectron) {
	      const { ipcRenderer } = await import('electron');
        ipcRenderer.send('app_version');
        ipcRenderer.on('app_version', (event, arg) => {
          ipcRenderer.removeAllListeners('app_version');
          version.innerText = 'Versão ' + arg.version;
        });
      }else{
          version.innerText = 'Versão ' + packageJson.version;
      }
  }
}
</script>
<style >
  .test{
    background-color: orange !important;
    height: 20px;
    z-index: 10000000;
  }

</style>